import React, { Fragment } from 'react';

export const getHighlightedText = (text: string, highlight: string) => {
    if (!highlight) return text;

    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return parts.map((part, index) => (
        <Fragment key={index}>
            {part.toLowerCase() === escapedHighlight.toLowerCase() ? <b>{part}</b> : part}
        </Fragment>
    ));
};
